// Whether the support composer is on screen, for parts of the page that offer it instead of a form of
// their own (the landing page footer's "Chat with us"), and the event that opens it. SupportDock says
// what it shows; the composer listens for the event. Kept apart from the composer, whose code loads
// only when it is shown.

export const OPEN_EVENT = 'lt-support-open';
// Sent on a small screen when the support conversation opens: sheets kept in page state (the menu's Categories
// sheet) close, so they can't cover it.
export const PANEL_OPEN_EVENT = 'lt-support-panel-open';

let composerShown = false;
const listeners = new Set();

export function isComposerShown() {
  return composerShown;
}

export function setComposerShown(shown) {
  const next = !!shown;
  if (next === composerShown) return;
  composerShown = next;
  listeners.forEach(listener => listener(next));
}

/** Calls listener(shown) on every change; returns the function that stops it. */
export function subscribeComposerShown(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * Opens the composer: its conversation, or the first thing to fill in. detail.text, when given, goes
 * into an empty message box (an error's reference, from "Contact support").
 */
export function notifySupportPanelOpen() {
  let event;
  try {
    event = new window.CustomEvent(PANEL_OPEN_EVENT);
  } catch (e) {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(PANEL_OPEN_EVENT, false, false, null);
  }
  window.dispatchEvent(event);
}

export function openSupportComposer(detail = null) {
  let event;
  try {
    event = new window.CustomEvent(OPEN_EVENT, { detail });
  } catch (e) {
    // Browsers without the CustomEvent constructor.
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(OPEN_EVENT, false, false, detail);
  }
  window.dispatchEvent(event);
}



// WEBPACK FOOTER //
// ./src/support/supportEntry.js